import { Dropdown, DropdownMenuItemProps } from '../../Dropdown';
import { Icons } from '../../Icons';
import { GroupingConfig } from '../types';
import { TableGlobalActionTrigger } from './TableGlobalActionTrigger';

const GlobalGroupingTool = <TData,>({
  groupingConfig,
}: {
  groupingConfig?: GroupingConfig<TData>;
}) => {
  if (
    !groupingConfig?.toolbar?.isEnabled ||
    !groupingConfig.toolbar.options.length
  ) {
    return null;
  }

  const { toolbar } = groupingConfig;
  const hasActiveGrouping = toolbar.value !== null;

  const clearGrouping = () => {
    toolbar.onChange(null);
  };

  const createGroupingMenuItems = () => {
    const items: DropdownMenuItemProps[] = [];

    // Add grouping options only (no "No grouping" entry)
    toolbar.options.forEach((option) => {
      const isSelected = toolbar.value === option.id;

      items.push({
        label: option.label,
        onClick: () => toolbar.onChange(option.id),
        className: isSelected ? 'bg-bg-secondary' : '',
        shortcut: isSelected ? (
          <Icons.Check className="size-4 text-fg-brand" />
        ) : undefined,
      });
    });

    return items;
  };

  const menu = {
    groups: [
      {
        items: createGroupingMenuItems(),
      },
    ],
  };

  return (
    <Dropdown
      menu={menu}
      align="start"
      contentClassName="w-[270px]"
      side="bottom"
      sideOffset={8}
    >
      <TableGlobalActionTrigger
        count={hasActiveGrouping ? 1 : 0}
        onClear={clearGrouping}
        icon={<Icons.Grid01 className="size-4" />}
        label="Group"
      />
    </Dropdown>
  );
};

export { GlobalGroupingTool };
